// removed by extract-text-webpack-plugin
module.exports = {"fieldCoupon_input":"FieldTextAction-m__fieldCoupon_input___2QAMR","fieldCouponInput":"FieldTextAction-m__fieldCoupon_input___2QAMR","fieldCoupon_apply":"FieldTextAction-m__fieldCoupon_apply___31tv5","fieldCouponApply":"FieldTextAction-m__fieldCoupon_apply___31tv5"};


//////////////////
// WEBPACK FOOTER
// ./components/fields/fieldTextAction/FieldTextAction.m.sass
// module id = WZ3C
// module chunks = 0